module.exports = __webpack_public_path__ + "assets/images/c4dd1072644ecfa900b972e07e19c86a.png";